import type {NamedSetState} from 'app/gemStore/devtools';

import type {OauthClientSlice, OauthClientState} from './types';

const initialOauthClientState: OauthClientState = {
    isAuthorized: false,
    accessToken: null,
};

export const createOauthClientSlice = (set: NamedSetState<OauthClientSlice>) => ({
    oauthClient: {...initialOauthClientState},
    setOauthAuthorizationSuccess: (accessToken: string) =>
        set(
            {
                oauthClient: {
                    isAuthorized: true,
                    accessToken,
                },
            },
            false,
            'oauthClient/setOauthAuthorizationSuccess',
        ),
    clearOauthAccessToken: () =>
        set(
            {
                oauthClient: {
                    isAuthorized: false,
                    accessToken: null,
                },
            },
            false,
            'oauthClient/clearOauthAccessToken',
        ),
});
